import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function AccessSection() {
  const { accessData } = useHomeData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <ScrollReveal direction="up">
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={accessData.image}
                  alt="ヘリポートアクセス"
                  className="w-full h-80 md:h-[28rem] object-cover object-top"
                />
              </div>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={150}>
              <div>
                <p className="section-label mb-3">{accessData.label}</p>
                <h2 className="section-title">{accessData.title}</h2>
                <p className="mt-5 text-base text-airdoa-gray leading-[1.9]">{accessData.description}</p>
                <Link to={accessData.cta.href} className="btn-primary mt-8 inline-flex">
                  {accessData.cta.label}
                </Link>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}